import { Data } from './data';
import { ApiFile } from './apifile';
import { Permission } from './permission';

export class User extends Data {

    username: string;
    email: string;
    plainPassword: string;
    nom: string;
    prenom: string;
    adresse: string;
    civility: string;
    telephone: string;
    photo: ApiFile;
    date_naissance: any;
    selectedPhotoFile: File;
    is_active: boolean;
    permissions: Permission[];
   
    constructor() {

      super();
        
    }

    get converBirthdayToNgbDateStruct(): any {
  
      if (this.date_naissance !== null && this.date_naissance !== undefined) {
        const tab = this.date_naissance.split(' ');
        const tab2 = tab[0].split('-');
        return {
          year: Number( tab2[0]),
          month: Number( tab2[1]),
          day: Number( tab2[2]),
        };
      } else {
        return null;
      }
    
    }

    get nomComplet(): string {
      if( this.nom !== null && this.prenom !== null && this.nom !== undefined && this.prenom !== undefined)
      return this.nom + ' ' + this.prenom;
      else {
        if( this.nom !== null && this.nom !== undefined)
        return this.nom
        else {
          if( this.prenom === null || this.prenom === undefined)
          return '';
        }
      }
    }

    
    
    
}